// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Chart = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 11a2 2 0 1 1 4 0v72a1 1 0 0 0 1 1h72a2 2 0 1 1 0 4H11a2 2 0 0 1-2-2V11Zm71 24.828V45a2 2 0 1 0 4 0V32a3 3 0 0 0-3-3H67a2 2 0 1 0 0 4h10.172L53.525 56.647 42.353 45.075a4 4 0 0 0-5.706-.05l-19.061 19.06a2 2 0 1 0 2.828 2.83l19.061-19.062 11.172 11.572a4 4 0 0 0 5.706.05L80 35.828Z"
			fill="#fff"
		/>
	</svg>
);
export default Chart;
